// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.notification-menu.v-card[data-v-11d08998] {
  border-radius: 0;
  background-color: #eee;
  position: relative;
  overflow: hidden;
}
/*removed the radius of card*/
.notification-menu[data-v-11d08998] .v-list {
  padding: 0px;
  background-color: transparent;
}
/*Change bg color notification list*/
.notification-menu[data-v-11d08998] .v-list .v-list__tile__content {
  width: 100%;
}
.notification-menu[data-v-11d08998] .v-list > div {
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
}
/*Add bg color in notification list item*/
.notification-menu[data-v-11d08998] .v-list > div:last-child {
  margin-bottom: 0px;
}
.notification-menu[data-v-11d08998] .v-list .v-list__tile {
  padding: 0px 10px;
}
.notification-menu[data-v-11d08998] .v-list .v-list__tile__avatar {
  min-width: 42px;
  max-width: 42px;
}
.v-badge[data-v-11d08998] .v-badge__badge {
  top: 0;
  right: 0;
}
/*to set bedge icon position*/
.n-arrow[data-v-11d08998] {
  transition: all 0.3s linear;
  border-color: transparent;
  border-bottom-color: #fff;
  border-style: dashed dashed solid;
  border-width: 0 8.5px 8.5px;
  position: absolute;
  left: 13px;
  top: 50px;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
}
.v-menu__activator.v-menu__activator--active .n-arrow[data-v-11d08998] {
  top: 37px;
  z-index: 1;
  opacity: 1;
  visibility: visible;
}
.notification-menu[data-v-11d08998] .vb-dragger {
  right: 4px;
}
.notification-bell[data-v-11d08998] .v-badge--overlap .v-badge__badge {
  top: -7px;
  right: -11px;
}
.notification-menu[data-v-11d08998] .v-list--three-line .v-list__tile {
  height: 92px;
}
.icon-img[data-v-11d08998] img {
  max-width: 24px;
}
.vip-customer[data-v-11d08998] img {
  max-width: 19px;
}
.icon-img[data-v-11d08998] img.asbestos-icon {
  max-width: 28px;
}
.notification-bell[data-v-11d08998] .v-badge--overlap {
  top: -2px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
